import React from "react";
import { motion } from "framer-motion";
import styled from "@emotion/styled";
import { FlexContainer } from "../../../containers/FlexContainer";
import { css } from "@emotion/react";
import { withIsVisible } from "../../../utils/reactUtils";

const LoadingEllipse = ({
  ellipseSize,
  gapBetweenDot,
  color,
}: {
  ellipseSize?: number;
  gapBetweenDot?: number;
  color?: string;
}) => {
  return (
    <FlexContainer
      css={css`
        margin-right: 0.5em;
      `}
    >
      <AnimatedEllipse
        ellipseSize={ellipseSize}
        animate={{ y: [0, -5, 1] }}
        transition={{ duration: 1.5, repeat: Infinity }}
        gapBetweenDot={gapBetweenDot}
        color={color}
      ></AnimatedEllipse>
      <AnimatedEllipse
        ellipseSize={ellipseSize}
        animate={{ y: [0, -5, 1] }}
        transition={{ duration: 1.5, repeat: Infinity, delay: 0.3 }}
        gapBetweenDot={gapBetweenDot}
        color={color}
      ></AnimatedEllipse>
      <AnimatedEllipse
        ellipseSize={ellipseSize}
        animate={{ y: [0, -5, 1] }}
        transition={{ duration: 1.5, repeat: Infinity, delay: 0.6 }}
        gapBetweenDot={gapBetweenDot}
        color={color}
      ></AnimatedEllipse>
    </FlexContainer>
  );
};

const AnimatedEllipse = styled(motion.div)<{
  ellipseSize?: number;
  gapBetweenDot?: number;
  color?: string;
}>`
  width: ${props => (props.ellipseSize ? `${props.ellipseSize}px` : "2px")};
  height: ${props => (props.ellipseSize ? `${props.ellipseSize}px` : "2px")};
  margin-left: ${props => (props.gapBetweenDot ? `${props.gapBetweenDot}px` : "2px")};
  margin-right: ${props => (props.gapBetweenDot ? `${props.gapBetweenDot}px` : "2px")};
  border-radius: 50%;
  background: ${props => (props.color ? props.color : props.theme.icon.primary.default)};
`;

export default withIsVisible(LoadingEllipse);
